import {
    ADMIN_DELETE_POPULARLOCATION_START,
    ADMIN_DELETE_POPULARLOCATION_SUCCESS,
    ADMIN_DELETE_POPULARLOCATION_ERROR
} from '../../constants';
import history from '../../core/history';
import showToaster from '../../helpers/showToaster';
import {
    getPopularLocation as query, deletePopularLocation as mutation,
    updatePopularLocationStatusMutation
} from '../../lib/graphql';

export function deletePopularLocation(id, currentPage) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: ADMIN_DELETE_POPULARLOCATION_START,
                data: id
            });

            const { data } = await client.mutate({
                mutation,
                variables: { id },
                refetchQueries: [{ query, variables: { currentPage } }]
            });

            if (data?.deletePopularLocation?.status == "200") {
                dispatch({
                    type: ADMIN_DELETE_POPULARLOCATION_SUCCESS,
                });
                showToaster({ messageId: 'deleteSuccess', toasterType: 'success' })
                history.push('/siteadmin/popularlocation');
                return { status: 200 };
            } else {
                showToaster({ messageId: 'deleteFailed', toasterType: 'error' })
            }
        } catch (error) {
            dispatch({
                type: ADMIN_DELETE_POPULARLOCATION_ERROR,
                payload: {
                    error
                }
            });
        }
    };
}

export function updateLocationStatus(id, isEnable) {
    return async (dispatch, getState, { client }) => {
        try {
            const { data } = await client.mutate({
                mutation: updatePopularLocationStatusMutation,
                variables: { id, isEnable }
            });

            if (data?.updatePopularLocationStatus?.status === "success") {
                showToaster({ messageId: 'updatePopularLocation', toasterType: 'success' })
            }

        } catch (error) {
            showToaster({ messageId: 'updateLocationError', toasterType: 'error' })
            return false;
        }
        return true;
    };
}